import gql from 'graphql-tag'
import { GeoItemFragment } from './getDashboardDSGeo'

const mutation = gql`
mutation createDashboardDSGeo($branch: Int!, $googleMapUrl: String!) {
  cashAssist {
    createDashboardDSGeo(branch: $branch, googleMapUrl: $googleMapUrl) {
      ...GeoItemFragment
    }
  }
}
${GeoItemFragment}
`

export default mutation
